<template>
  <div v-if="asyncDataStatus_ready" class="col-full push-top">
    <h2>
      Uredi prostor:
    </h2>

    <LocationForm
      @save="save"
      @cancel="cancel"
      :location="location"
    />

    <div class="row mt-10">
      <div class="col">
        <h2>
          Mize:
        </h2>
      </div>
      <div class="col">
        <v-btn
          color="#0F998E"
          class="white--text float-right"
          @click="saveOrder"
        >
          Shrani vrstni red
          <v-icon right dark>mdi-check</v-icon>
        </v-btn>
        <v-btn
          color="#0F998E"
          class="white--text float-right mr-5"
          @click="sortAbc"
        >
          Po abecedi
          <v-icon right dark>mdi-sort-alphabetical</v-icon>
        </v-btn>
      </div>
    </div>
      <v-col>
        <v-simple-table fixed-header>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">
                  Miza
                </th>
                <th></th>
              </tr>
            </thead>
          </template>
        </v-simple-table>
      </v-col>
    <v-row v-dragula="localTables" drake="tables">

      <v-col cols="12" class="pt-0 pb-0" :style="{'border-bottom': `5px solid ${item.color}`}" v-for="item of localTables" :key="item.id">
        <TitleOnlyCard
          :title="item.name"
          :editable="true"
          :deleteable="false"
          :draggable="true"
          @edit="$router.push({name: 'MyCompanyTablesEdit', params: {id: item.id, redirect: 'MyCompanyLocationsEdit', redirectParams: { id: id } }})"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { saveItem } from '@/utils/crudFunctions'
import LocationForm from '@/components/LocationForm'
import TitleOnlyCard from '@/components/TitleOnlyCard'
import asyncDataStatus from '@/mixins/asyncDataStatus'

export default {
  components: {
    LocationForm,
    TitleOnlyCard
  },
  mixins: [
    asyncDataStatus
  ],
  props: {
    id: {
      required: true,
      type: Number
    }
  },
  data () {
    return {
      localTables: []
    }
  },
  computed: {
    location () {
      return this.$store.state.locations.items[this.id]
    },
    tables () {
      return Object.values(this.$store.state.tables.items).filter(t => t.location === this.id)
    }
  },
  methods: {
    ...mapActions('locations', ['loadItem', 'saveItem']),
    ...mapActions('tables', { loadTables: 'loadItems' }),
    ...mapActions('tables', ['updateTablesOrder']),
    save ({ data }) {
      saveItem(data, 'MyCompanyLocations', this)
    },
    cancel () {
      this.$router.replace({ name: 'MyCompanyLocations' })
    },
    saveOrder () {
      const updates = []
      this.localTables.forEach((item, i) => {
        updates.push({
          id: item.id,
          sort_order: i + 1
        })
      })
      this.updateTablesOrder(updates)
        .then(() => {
          /* this.$notify({
            type: 'success',
            text: 'Podatki so bili uspešno shranjeni.'
          }) */
        })
    },
    sortAbc () {
      this.localTables.sort((a, b) => (a.name > b.name) ? 1 : -1)
    }
  },
  created () {
    this.loadItem(this.id)
      .then(item => {
        this.loadTables()
          .then(items => {
            this.localTables = this.tables.sort((a, b) => (a.sort_order > b.sort_order) ? 1 : -1)
            this.asyncDataStatus_fetched()
          })
      })
  }
}
</script>
